import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
import VerticalBarChart from '../core/VerticalBarChart';
import { Playground } from 'docz';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "vertical-bar-chart-example"
    }}>{`Vertical bar chart example`}</h1>
    <Playground __position={0} __code={'<VerticalBarChart\n  showBarLabel\n  yComplement=\"%\"\n  xType=\"category\"\n  yType=\"value\"\n  color=\"green\"\n  title=\"Bar Chart example\"\n  toolboxTooltip={{ saveAsImage: \'save\' }}\n  tooltip={{ label: \'Equipamento\', result: \'Disponibilidade\' }}\n  data={[\n    {\n      label: \'NG209131231\',\n      result: \'100\',\n      itemId: 1,\n    },\n    {\n      label: \'NG21021313\',\n      result: \'10\',\n      itemId: 1,\n    },\n    {\n      label: \'NG211131231\',\n      result: \'100\',\n      itemId: 1,\n    },\n    {\n      label: \'NG21221312313\',\n      result: \'100\',\n      itemId: 1,\n    },\n    {\n      label: \'NG213133123\',\n      result: \'100\',\n      itemId: 1,\n    },\n    {\n      label: \'NG2142232313\',\n      result: \'100\',\n      itemId: 1,\n    },\n    {\n      label: \'NG2151111\',\n      result: \'10\',\n      itemId: 1,\n    },\n    {\n      label: \'NG216444533\',\n      result: \'100\',\n      itemId: 1,\n    },\n    {\n      label: \'NG2172222\',\n      result: \'100\',\n      itemId: 1,\n    },\n    {\n      label: \'NG21822222\',\n      result: \'100\',\n      itemId: 1,\n    },\n    {\n      label: \'NG2192222222222\',\n      result: \'10\',\n      itemId: 1,\n    },\n    {\n      label: \'NG22022222222222\',\n      result: \'100\',\n      itemId: 1,\n    },\n    {\n      label: \'NG22122222222\',\n      result: \'100\',\n      itemId: 1,\n    },\n    {\n      label: \'NG2222222222222\',\n      result: \'100\',\n      itemId: 1,\n    },\n    {\n      label: \'31\',\n      result: \'100\',\n      itemId: 1,\n    },\n    {\n      label: \'3\',\n      result: \'10\',\n      itemId: 1,\n    },\n    {\n      label: \'31\',\n      result: \'100\',\n      itemId: 1,\n    },\n    {\n      label: \'2313\',\n      result: \'100\',\n      itemId: 1,\n    },\n    {\n      label: \'23\',\n      result: \'100\',\n      itemId: 1,\n    },\n    {\n      label: \'313\',\n      result: \'100\',\n      itemId: 1,\n    },\n    {\n      label: \'45\',\n      result: \'10\',\n      itemId: 1,\n    },\n    {\n      label: \'33\',\n      result: \'100\',\n      itemId: 1,\n    },\n    {\n      label: \'89\',\n      result: \'100\',\n      itemId: 1,\n    },\n    {\n      label: \'299\',\n      result: \'100\',\n      itemId: 1,\n    },\n    {\n      label: \'222222\',\n      result: \'10\',\n      itemId: 1,\n    },\n    {\n      label: \'222484842222\',\n      result: \'100\',\n      itemId: 1,\n    },\n    {\n      label: \'2222\',\n      result: \'100\',\n      itemId: 1,\n    },\n    {\n      label: \'22222552\',\n      result: \'100\',\n      itemId: 1,\n    },\n  ]}\n/>'} __scope={{
      props,
      DefaultLayout,
      VerticalBarChart,
      Playground,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <VerticalBarChart showBarLabel yComplement='%' xType='category' yType='value' color='green' title='Bar Chart example' toolboxTooltip={{
        saveAsImage: 'save'
      }} tooltip={{
        label: 'Equipamento',
        result: 'Disponibilidade'
      }} data={[{
        label: 'NG209131231',
        result: '100',
        itemId: 1
      }, {
        label: 'NG21021313',
        result: '10',
        itemId: 1
      }, {
        label: 'NG211131231',
        result: '100',
        itemId: 1
      }, {
        label: 'NG21221312313',
        result: '100',
        itemId: 1
      }, {
        label: 'NG213133123',
        result: '100',
        itemId: 1
      }, {
        label: 'NG2142232313',
        result: '100',
        itemId: 1
      }, {
        label: 'NG2151111',
        result: '10',
        itemId: 1
      }, {
        label: 'NG216444533',
        result: '100',
        itemId: 1
      }, {
        label: 'NG2172222',
        result: '100',
        itemId: 1
      }, {
        label: 'NG21822222',
        result: '100',
        itemId: 1
      }, {
        label: 'NG2192222222222',
        result: '10',
        itemId: 1
      }, {
        label: 'NG22022222222222',
        result: '100',
        itemId: 1
      }, {
        label: 'NG22122222222',
        result: '100',
        itemId: 1
      }, {
        label: 'NG2222222222222',
        result: '100',
        itemId: 1
      }, {
        label: '31',
        result: '100',
        itemId: 1
      }, {
        label: '3',
        result: '10',
        itemId: 1
      }, {
        label: '31',
        result: '100',
        itemId: 1
      }, {
        label: '2313',
        result: '100',
        itemId: 1
      }, {
        label: '23',
        result: '100',
        itemId: 1
      }, {
        label: '313',
        result: '100',
        itemId: 1
      }, {
        label: '45',
        result: '10',
        itemId: 1
      }, {
        label: '33',
        result: '100',
        itemId: 1
      }, {
        label: '89',
        result: '100',
        itemId: 1
      }, {
        label: '299',
        result: '100',
        itemId: 1
      }, {
        label: '222222',
        result: '10',
        itemId: 1
      }, {
        label: '222484842222',
        result: '100',
        itemId: 1
      }, {
        label: '2222',
        result: '100',
        itemId: 1
      }, {
        label: '22222552',
        result: '100',
        itemId: 1
      }]} mdxType="VerticalBarChart" />
    </Playground>
    <h1 {...{
      "id": "vertical-bar-chart-example-with-custommaxdomain"
    }}>{`Vertical bar chart example with customMaxDomain`}</h1>
    <Playground __position={1} __code={'<VerticalBarChart\n  showBarLabel\n  yComplement={value => `R$ ${value},00`}\n  xType=\"category\"\n  yType=\"value\"\n  color=\"blue\"\n  title=\"Bar Chart example\"\n  customMaxDomain={3000}\n  toolboxTooltip={{ saveAsImage: \'save\' }}\n  tooltip={{ label: \'Equipamento\', result: \'Disponibilidade\' }}\n  data={[\n    {\n      label: \'NG209131231\',\n      result: \'2057\',\n    },\n    {\n      label: \'NG21021313\',\n      result: \'20\',\n    },\n  ]}\n/>'} __scope={{
      props,
      DefaultLayout,
      VerticalBarChart,
      Playground,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <VerticalBarChart showBarLabel yComplement={value => `R$ ${value},00`} xType='category' yType='value' color='blue' title='Bar Chart example' customMaxDomain={3000} toolboxTooltip={{
        saveAsImage: 'save'
      }} tooltip={{
        label: 'Equipamento',
        result: 'Disponibilidade'
      }} data={[{
        label: 'NG209131231',
        result: '2057'
      }, {
        label: 'NG21021313',
        result: '20'
      }]} mdxType="VerticalBarChart" />
    </Playground>
    <h1 {...{
      "id": "vertical-bar-chart-with-dateformat"
    }}>{`Vertical bar chart with dateFormat`}</h1>
    <Playground __position={2} __code={'<VerticalBarChart\n  showBarLabel\n  title=\"Bar Chart example\"\n  xType=\"time\"\n  yComplement=\"%\"\n  dateFormat=\"yyyy-MM\"\n  color=\"blue\"\n  customMaxDomain={100}\n  toolboxTooltip={{ saveAsImage: \'save as image\' }}\n  tooltip={{ label: \'Date\', result: \'Disp\' }}\n  data={[\n    {\n      label: \'2020-01\',\n      result: \'50\',\n    },\n  ]}\n/>'} __scope={{
      props,
      DefaultLayout,
      VerticalBarChart,
      Playground,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
      <VerticalBarChart showBarLabel title="Bar Chart example" xType="time" yComplement="%" dateFormat="yyyy-MM" color="blue" customMaxDomain={100} toolboxTooltip={{
        saveAsImage: 'save as image'
      }} tooltip={{
        label: 'Date',
        result: 'Disp'
      }} data={[{
        label: '2020-01',
        result: '50'
      }]} mdxType="VerticalBarChart" />
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      